import moment from 'moment';
export function hoursToDays(hours) {
    try {
        var duration = moment.duration(hours, 'hours');
        var days = Math.floor(duration.asDays());
        var remainingHours = duration.hours();
        var text = "";

        text += days > 0 ? days + " ngày " : "";
        text += remainingHours > 0 ? remainingHours + " giờ " : "";
       // text += minutesPart > 0 ? minutesPart + " phút " : "";
        return text;
    } catch (error) {
        return "Lỗi: " + error;
    }
}